module.exports = __webpack_public_path__ + "img/20180815_145911_040.ad105da7.jpg";